import './App.css';
// import Header from './Components/Common/Header'
import Home from './Components/Pages/Home'

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
